import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

const formatCurrencyNoSymbol = (amount = 0) =>
  new Intl.NumberFormat("es-DO", {
    style: "decimal",
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  }).format(amount);

export function CurrencyInput({ value, onChange, readOnly, disabled, style, ...rest }) {
  const [displayValue, setDisplayValue] = useState(
    formatCurrencyNoSymbol(value || 0)
  );
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    if (!isFocused) {
      setDisplayValue(formatCurrencyNoSymbol(value || 0));
    }
  }, [value, isFocused]);

  return (
    <Form.Control
      {...rest}
      style={{ textAlign: 'right', ...style }}
      readOnly={readOnly}
      disabled={disabled}
      type="text"
      value={isFocused ? displayValue : formatCurrencyNoSymbol(value || 0)}
      onFocus={(e) => {
        if (readOnly || disabled) return;
        setIsFocused(true);
        setDisplayValue(String(value || ""));
        setTimeout(() => e.target.select(), 0);
      }}
      onBlur={() => {
        if (readOnly || disabled) return;
        setIsFocused(false);
        const numeric = parseFloat(displayValue.replace(/[^0-9.]/g, "")) || 0;
        setDisplayValue(formatCurrencyNoSymbol(numeric));
        onChange(numeric);
      }}
      onChange={(e) => {
        if (readOnly || disabled) return;
        setDisplayValue(e.target.value);
        const numeric = parseFloat(e.target.value.replace(/[^0-9.]/g, "")) || 0;
        onChange(numeric);
      }}
    />
  );
}

export default CurrencyInput;
